import moment from "moment";

import { authGet } from "@api";
import { TimeLookbackRange } from "@types";
import { calculateLookbackSeconds } from "@utils/calculateLookbackSeconds";

import { DeploymentSummaryStats } from "@pages/overview/types";

// don't call this function directly, use useDeploymentSummaryStats instead
export const fetchDeploymentSummaryStats = (
  deploymentId: string,
  timeLookbackRange: TimeLookbackRange,
  reposFilter: string[],
  until: number = moment().unix()
): Promise<DeploymentSummaryStats> => {
  const since = calculateLookbackSeconds(timeLookbackRange);
  const reposParam =
    reposFilter.length > 0 ? `&repo=${reposFilter.join(",")}` : "";
  return authGet<DeploymentSummaryStats>(
    `/api/agent/deployments/${deploymentId}/analytics/summary?since=${since}&until=${until}${reposParam}`
  );
};
